import React, { useEffect } from 'react';
import BaseballMatchBroadcastStore from './store';
import { useParams } from 'react-router-dom';
import BaseballBroadCastItem from './item';
import NoneBroadcast from '../../../../../components/noneBroadcast';
import SportsLoader from '../../../../../components/sportsLoader';
import Seo from '../../../../../components/seo';

const BaseballMatchBroadcast = () => {
  let { id } = useParams();
  const { getBroadcast, closeSocket, data } = BaseballMatchBroadcastStore();

  useEffect(() => {
    getBroadcast(id);

    return () => {
      closeSocket();
    };
  }, []);

  let broadcastComps = [];
  if (data.getPeriodBroadcast !== null) {
    for (let [key, value] of Object.entries(data.getPeriodBroadcast)) {
      broadcastComps.unshift(
        <BaseballBroadCastItem
          key={key}
          data={value}
          period={key}
          selectedPeriod={data.selectedPeriod}
        />
      );
    }
  }

  return (
    <div className="baseball_cast">
      <Seo title={'스포츠 야구 상세 중계'} />
      {data.loading && <SportsLoader />}
      {!data.loading && broadcastComps.length > 0 && broadcastComps}
      {!data.loading && broadcastComps.length === 0 && <NoneBroadcast />}
    </div>
  );
};

export default BaseballMatchBroadcast;
